"use client";

import { Globe } from "lucide-react";
import { useTranslations } from "next-intl";
import { useContestDisplayZone } from "@/features/contests/lib/display-zone";

/** Which clock every time in "Rounds and contests" is on (`EX-PUB18`, `docs/04`). */
export function ContestZoneNote() {
  const t = useTranslations("judge.home");
  const zone = useContestDisplayZone();
  return (
    <p className="inline-flex min-h-[34px] items-center gap-2 rounded-full border border-white/15 px-3.5 py-1.5 text-[13px] text-neutral-400">
      <Globe className="h-4 w-4 shrink-0 text-primary" aria-hidden />
      <span>
        {t("zoneNote")}{" "}
        <span className="font-medium text-white">{zone === "UTC" ? t("zoneUtc") : t("zoneBangladesh")}</span>
      </span>
    </p>
  );
}
